<template>
  <div id="app" class="h-screen overflow-hidden bg-gray-50">
    <RouterView />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

onMounted(() => {
  // Initialize user authentication check
  userStore.checkAuth()
})
</script>
